export const de = {
  exitIntentModal: {
    headline: 'Bevor Sie gehen ...',
    subheadline: 'Derzeit bieten wir bei exzellenten Tutoren kostenlose Probestunden an.',
    content: {
      bulletpoints: [
        'Individueller Lernplan',
        'Lerntypenorientierter Unterricht',
        'Keine Anfahrt = Weniger Kosten',
        'Flexibler Fachwechsel',
        'Mit Spaß zu guten Noten',
      ],
    },
    button: 'Jetzt kostenlose Probestunde vereinbaren!',
  },
};
